/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { FormContainer } from './container';
import { useNavigate } from 'react-router-dom';

export const FormPage = (props: any) => {
  const history = useNavigate();

  return (
    <FormContainer
      {...props}
      onPaymentClick={() => history('/payment')}
      onRenew={(id?: any) =>
        history(`/renew-application-form${id ? `?id=${id}` : ''}`)
      }
    />
  );
};
